export default {
    name: 'set',
    path: 'set',
    meta: {
        title: '系统设置'
    },
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'set-we',
            path: 'we',
            meta: { title: '关于我们' },
            component: ()=>import('@/pages/set/we.vue')
        },
        {
            name: 'set-help',
            path: 'help',
            meta: { title: '帮助使用' },
            component: ()=>import('@/pages/set/help.vue')
        },
        {
            name: 'set-example',
            path: 'example',
            meta: { title: '案例展示' },
            component: ()=>import('@/pages/set/example.vue')
        }
    ]
}